export const DEFAULT_GROUP_ID = 'notify';
export const SMS_GROUP_ID = 'sms';
export const DETAIL_VENUE_PAGE_OTHER_BRANDS_TITLE = 'Explore other brands';
